import {
  observable, flow, computed, makeObservable,
} from 'mobx';
import TheoryAccessProvidersReviewsApi from '../api/theory_access_providers_review';
import BaseStore from './BaseStore';

const PER_PAGE_LIMIT = 7;

class TheoryAccessProvidersReviewsStore extends BaseStore {
  isReviewsDataLoading = false;
  isReviewSent = false;
  reviews = [];
  total;

  getReviews = flow(function* (providerId, page = 1) {
    this.isReviewsDataLoading = true;

    try {
      const { data } = yield TheoryAccessProvidersReviewsApi.getReviews(providerId, page, PER_PAGE_LIMIT);
      this.reviews = data.items;
      if (this.total !== data.total) {
        this.total = data.total;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error.response.data.errorMessages);
    } finally {
      this.isReviewsDataLoading = false;
    }
  });

  createReview = flow(function* (providerId, payload, setErrors) {
    this.isReviewPosting = true;

    try {
      yield TheoryAccessProvidersReviewsApi.postReview(providerId, payload);
      this.isReviewSent = true;
    } catch (error) {
      if (error.response) {
        setErrors(error.response.data.errorMessages);
      } else {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  });

  constructor() {
    super();

    makeObservable(this, {
      isReviewsDataLoading: observable,
      isReviewSent: observable,
      reviews: observable,
      total: observable,
      pageCount: computed,
    });
  }

  get pageCount() {
    return Math.ceil(this.total / PER_PAGE_LIMIT);
  }
}

export default new TheoryAccessProvidersReviewsStore();
